// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"2":"patient","123":"case","391":"info","430":"doctor","857":"report","962":"home","966":"login"}[chunkId] + "." + {"2":"2e29aee1","123":"b66efcfc","391":"56e109b9","430":"7f7b211d","857":"0fc75665","962":"88609112","966":"81a07d74"}[chunkId] + ".css";
};